import { buildSchema,buildProperty, buildCollection,ExtraActionsParams } from "@camberi/firecms";
import { FileUploader } from "react-drag-drop-files";
import Papa from "papaparse";
import { v4 as uuidv4 } from 'uuid';
import { fetchSignInMethodsForEmail, sendPasswordResetEmail } from "firebase/auth";
import Config from "../utils/config";
import { collection, doc, setDoc } from "firebase/firestore";





export default class Quests {

    constructor() {

    }

    static BuildCollection (isadmin:boolean, issuperadmin:boolean, groupname:string) {
      return buildCollection({
        path: "questRewards",
        group:groupname,
        exportable:false,
        schema: Quests.schema(),
        name: "Quest Rewards",
        permissions: ({entity,path,user,authController,context}) => { 
            return ({
                read: isadmin,
                create: isadmin,
                update: issuperadmin,
                delete: issuperadmin
            });
        },

    
      })
    }


    static schema () {
        return buildSchema({
            name: "Quest Rewards",
            properties: {
              
              name: {
                title: "Name",
                dataType: "string"
              },
              rewardType: {
                title: "Reward Type",
                dataType: "string",
                config: {
                  enumValues: {
                      XP: "Skill points",
                      Xsolla: "Xsolla Item",
                      XsollaCurrency: "Xsolla Currency",
                      defaultdeck: "default deck",
                      artcard: "art card"
                  }
                }
              },
              rewardSKU: {
                title: "Reward SKU (if Xsolla) or ID (if firestore)",
                dataType: "string",
              },

              rewardAmount: {
                title: "Reward Amount",
                dataType: "number"
              },

              duration: {
                title: "Duration",
                dataType: "string",
                config: {
                  enumValues: {
                    Daily: "Daily",  
                    Weekly: "Weekly",
                    Monthly: "Monthly"
                  }
                }
              },

              difficulty: {
                title: "Difficulty",
                dataType: "string",
                config: {
                  enumValues: {
                    Easy: "Easy",  
                    Medium: "Medium",
                    Hard: "Hard"
                  }
                }
              },
                
            }
          });
    }


    
}